import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import "./index.scss";

import { actionUpdatePortalMapData } from "../../../store/reducers/portalMap/portalMap-actions";
import { PortalMapContext } from "../../../context/portalMap-context";
import { isSameObjects } from "../../../utils/objects-util";

class PortalServiceMap extends PureComponent {
  static contextType = PortalMapContext;

  constructor(props) {
    super(props);

    this.mapContainer = document.getElementById("map-container");
  }

  componentDidMount() {
    const { onMarkerClick, handleOnMapClick, onRegionChange } = this.props;
    const mapContainerService = document.getElementById(
      "map-container-service"
    );
    mapContainerService.appendChild(this.mapContainer);
    this.updateMapData();

    if(this.context && this.context.mapRef) {
      this.context.mapRef.registerHandlers({
        onMarkerClick,
        onMapClick: handleOnMapClick,
        onRegionChange
      });
    }

    this.refitTimeout = setTimeout(() => {
      if(this.context && this.context.mapRef && this.context.mapRef.refitViewport) {
        this.context.mapRef.refitViewport();
      }
    }, 0);
  }

  componentWillUnmount() {
    clearTimeout(this.refitTimeout);
    // const { updatePortalMapData } = this.props;
    const mapContainerService = document.getElementById("map-container-service");
    const mapBench = document.getElementById("map-bench");

    if(mapContainerService && 
      mapContainerService.removeChild && 
      this.mapContainer
    ) {
      mapContainerService.removeChild(this.mapContainer);
    }
    
    if(mapBench && mapBench.appendChild && this.mapContainer) {
      mapBench.appendChild(this.mapContainer);
    }

    //Init state
    // if (updatePortalMapData) {
    //   updatePortalMapData({ isInit: true });
    // }

    if(this.context && this.context.mapRef) {
      this.context.mapRef.unregisterHandlers();
    }    
  }

  componentDidUpdate(prevProps, prevState) {
    const { 
      markers, center, region, regions, circle, isHidePolygon, isReadonly, renderPolygonsFromBusiness, 
      onMarkerClick, handleOnMapClick, onRegionChange, boundsByRegion, boundsByRegions, boundsByCircle, alwaysShowPolygons,
      boundsLocations
    } = this.props;
    if (
      !isSameObjects(prevProps.markers, markers) ||
      !isSameObjects(prevProps.center, center) ||
      !isSameObjects(prevProps.region, region) ||
      !isSameObjects(prevProps.regions, regions) ||
      !isSameObjects(prevProps.circle, circle) ||
      !isSameObjects(prevProps.isHidePolygon, isHidePolygon) ||
      !isSameObjects(prevProps.isReadonly, isReadonly) ||
      !isSameObjects(prevProps.renderPolygonsFromBusiness, renderPolygonsFromBusiness) ||
      !isSameObjects(prevProps.alwaysShowPolygons, alwaysShowPolygons) ||
      !isSameObjects(prevProps.boundsByRegion, boundsByRegion) ||
      !isSameObjects(prevProps.boundsByRegions, boundsByRegions) ||
      !isSameObjects(prevProps.boundsByCircle, boundsByCircle) ||
      !isSameObjects(prevProps.boundsLocations, boundsLocations)
    ) {
      this.updateMapData();
    }

    if(onMarkerClick !== prevProps.onMarkerClick) {
      //Fix for function component
      this.context.mapRef.registerHandlers({
        onMarkerClick,
        onMapClick: handleOnMapClick,
        onRegionChange
      });
    }
  }

  updateMapData = () => {
    const { markers, center, region, regions, circle, isHidePolygon, isReadonly, updatePortalMapData, renderPolygonsFromBusiness, boundsByRegion, boundsByRegions, boundsByCircle, zoom, alwaysShowPolygons, boundsLocations } = this.props;
    updatePortalMapData({ markers, center, region, regions, circle, isHidePolygon, isReadonly, renderPolygonsFromBusiness, boundsByRegion, boundsByRegions, boundsByCircle, zoom, alwaysShowPolygons, boundsLocations });
  };

  render() {
    return (<div id="map-container-service" className={classNames("mapContainerService")} />);
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updatePortalMapData: data => dispatch(actionUpdatePortalMapData(data))
  };
};

export default connect(null, mapDispatchToProps)(PortalServiceMap);
